import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["pauseReason", "pauseButton", "unpauseButton"];

  async showQuickLook(event) {
    event.preventDefault();

    const paymentToken = this.data.get("paymentTokenValue");
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/schools/payments/${paymentToken}/quick-look/manage`, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        Accept: "text/vnd.turbo-stream.html",
      },
    });

    if (!response.ok) {
      alert("Unable to load payment manager right now.");
      return;
    }

    const quickViewElement = document.querySelector("#school-payment-quick-look");
    if (!quickViewElement) {
      alert("Quick look container not found.");
      return;
    }

    quickViewElement.classList.remove("u-hidden");
    const responseBody = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(responseBody, "text/html");

    quickViewElement.innerHTML = "";
    quickViewElement.appendChild(xmlDoc.body);
  }

  closeQuickLook(event) {
    event.preventDefault();
    const quickViewElement = document.querySelector("#school-payment-quick-look");
    if (quickViewElement) {
      quickViewElement.classList.add("u-hidden");
      quickViewElement.innerHTML = "";
    }
  }

  async pausePayout(event) {
    event.preventDefault();

    const reason = this.hasPauseReasonTarget ? this.pauseReasonTarget.value.trim() : "";
    if (!reason) {
      alert("Please add a pause reason.");
      return;
    }

    if (this.hasPauseButtonTarget) {
      this.pauseButtonTarget.disabled = true;
    }

    try {
      await this.sendPauseRequest("pause", { reason });
      window.location.reload();
    } catch (error) {
      alert(error.message || "Unable to pause payout.");
    } finally {
      if (this.hasPauseButtonTarget) {
        this.pauseButtonTarget.disabled = false;
      }
    }
  }

  async unpausePayout(event) {
    event.preventDefault();

    if (this.hasUnpauseButtonTarget) {
      this.unpauseButtonTarget.disabled = true;
    }

    try {
      await this.sendPauseRequest("unpause", {});
      window.location.reload();
    } catch (error) {
      alert(error.message || "Unable to unpause payout.");
    } finally {
      if (this.hasUnpauseButtonTarget) {
        this.unpauseButtonTarget.disabled = false;
      }
    }
  }

  async sendPauseRequest(action, payload) {
    const paymentToken = this.data.get("paymentTokenValue");
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/schools/payments/${paymentToken}/quick-look/${action}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.error || "Action failed");
    }
  }
}
